import { TblUserData } from "../../models/UserData";
import { State, Selector, Action, StateContext } from "@ngxs/store";
import { AddUserData, RemoveUserData } from "../actions/userData.action";

export class UserDataStateModel {
  userData: TblUserData;
}

@State({
  name: "userData",
  defaults: {
    userData: undefined,
  },
})
export class UserDataState {
  @Selector()
  static getUserData(state: UserDataStateModel) {
    return state.userData;
  }

  @Action(AddUserData)
  add(
    { patchState }: StateContext<UserDataStateModel>,
    { payload }: AddUserData
  ) {
    patchState({ userData: payload });
  }

  @Action(RemoveUserData)
  remove({ patchState }: StateContext<UserDataStateModel>) {
    patchState({ userData: undefined });
  }
}
